import React, {Component} from 'react';
import { Toast,NavBar,Picker} from 'antd-mobile';
import {billDetail} from "../../../../service/waterBillService";
import './index.less';
import moment from "moment";
import {connect} from "react-redux";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class DealDetail extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            sourceId:'',
            amount:'',
            notes:'',
            createTime:'',
            billType:'',
            businessType:'',
            userType:'',
            source:'',
        };
    }

    componentDidMount() {
       this.getBillDetail();
    }
    getBillDetail = () =>{
        let params = {
            token: this.props.userInfo.token,
            "data":
            {
                'id':this.props.history.location.state.id
            }
        };
        Toast.loading("正在加载",0);
        billDetail(params).then((res) => {
            Toast.hide();
            console.log(res)
            if (res.data.code === '0000') {
                let data = res.data.data
                this.setState({
                    sourceId:data.sourceId,
                    amount:data.amount,
                    notes:data.notes,
                    createTime:data.createTime,
                    billType:data.billType,
                    businessType:data.businessType,
                    userType:data.userType,
                    source:data.source
                })
            } else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            } else {
                Toast.info(res.data.msg);
            }
        })
    }
    icon  =(v) => {
        if(v === 1 || v === 5 || v === 6 || v===8 || v===9){
            return 'icon iconfont iconxiadantubiao'
        }
        if(v === 2 || v === 3 || v === 4){
            return 'icon iconfont iconfenliuyewu'
        }
        if(v === 10){
            return 'icon iconfont icondaihuo'
        }
    }
    type =(v) => {
       
        if(v === 1){
            return '预约出行'
        }
        if(v === 2){
            return '分流'
        }
        if(v === 3){
            return '城内'
        }
        if(v === 4){
            return '专车预约'
        }
        if(v === 5){
            return '接驳'
        }
        if(v === 10){
            return '带货'
        }
    }
    userType =(v) => {
       
        if(v === 0){
            return '主线司机'
        }
        if(v === 1){
            return '分流司机'
        }
        if(v === 2){
            return '城内司机'
        }
        if(v === 3){
            return '主线调度'
        }
        if(v === 4){
            return '分流调度'
        }
        if(v === 5){
            return '城内调度'
        }
        if(v === 6){
            return '专车预约司机'
        }
        if(v === 7){
            return '专车预约调度'
        }
        if(v === 8){
            return '接驳司机'
        }
        if(v === 9){
            return '接驳调度'
        }
        if(v === 10){
            return '带货订单'
        }
    }
    render() {
        return (
            <div className="dealDetail">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() =>this.props.history.goBack()}></i>}
                >交易详情</NavBar>
                <div className="bgwhite">
                    <div className="header">
                        <div className="iconContent"><div><i className={this.icon(this.state.source)}/></div></div>
                        <span>{this.state.notes}</span>
                        <p>{this.state.amount}</p>
                    </div>
                    <div className="detail">
                        <div><span>交易时间</span><p>{this.state.createTime}</p></div>
                        <div><span>所属角色</span><p>{this.userType(this.state.userType)}</p></div>
                        <div><span>业务类型</span><p>{this.type(this.state.businessType)}</p></div>
                        <div><span>流水类型</span><p>{this.state.billType === 0 ? '收入':'支出'}</p></div>
                        <div><span>流水名称</span><p>{this.state.notes}</p></div>
                        <div><span>关联订单</span><p>{this.state.sourceId}</p></div>
                    </div>
                </div>
                <div className="callUs"><span>联系客服</span><a href='tel:4001389889'>400 - 138 - 9889</a></div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/Index/DealDetail/index.js